import { applyMiddleware, compose, createStore } from 'redux'
import { createEpicMiddleware } from 'redux-observable'
import { makeRootReducer } from './reducers'
import reduxReset from 'redux-reset'


export const epicMiddleware = createEpicMiddleware()

export const configureStore = (initialState = {}) => {
  const enhancers = [reduxReset()]
  const middleware = [epicMiddleware]
  const composeEnhancers = (window && window['__REDUX_DEVTOOLS_EXTENSION_COMPOSE__']) || compose

  const rootReducer = makeRootReducer()

  const store = createStore(
    rootReducer,
    initialState,
    composeEnhancers(applyMiddleware(...middleware), ...enhancers),
  )

  return { store }
}
